import { Component, OnInit, AfterViewInit } from '@angular/core';

import { EventService } from '../core/services/event.service';

import {
  LAYOUT_VERTICAL, LAYOUT_HORIZONTAL
} from './layouts.model';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit, AfterViewInit {
  usuario: any;
  // layout related config
  layoutType: string;

  constructor(private eventService: EventService) {
    this.usuario = JSON.parse(sessionStorage.getItem('currentUser'));
  }

  ngOnInit() {
    // default settings
    if (this.usuario.tipousuarioweb > 1) {
      this.layoutType = LAYOUT_HORIZONTAL;
    } else {
      this.layoutType = LAYOUT_VERTICAL;
    }
    //this.layoutType = LAYOUT_VERTICAL;
    //this.layoutType = LAYOUT_HORIZONTAL;
    // listen to event and change the layout, theme, etc
    this.eventService.subscribe('changeLayout', (layout) => {
      this.layoutType = layout;
    });
  }

  ngAfterViewInit() {
  }

  /**
   * Check if the vertical layout is requested
   */
  isVerticalLayoutRequested() {
    return this.layoutType === LAYOUT_VERTICAL;
  }

  /**
   * Check if the horizontal layout is requested
   */
  isHorizontalLayoutRequested() {
    return this.layoutType === LAYOUT_HORIZONTAL;
  }
}
